import clsx from 'clsx';

type statItemT = {
  title: string;
  value: number | string | undefined | null;
  subtitle?: string;
  icon?: string;
  color?: string;
  subValue?: number | string | undefined | null;
  cardClass: string;
};

type statsRowT = statItemT[];

type StatsRowPropsT = {
  stats: statsRowT;
  columns?: number;
};

export const PositionDetailStats = ({stats = [], columns = 5}: StatsRowPropsT) => {
  if (stats.length === 0) return null;

  return (
    <div
      className={clsx(
        'grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3',
        `xl:grid-cols-${columns} 2xl:grid-cols-${columns}`
      )}
    >
      {stats.map(
        (stat, index) =>
          stat.value !== undefined &&
          stat.value !== null && (
            <div key={index} className="!text-white">
              <div className={clsx('box !mb-0 !bg-primary', stat.cardClass)}>
                <div className="box-body !px-4 !py-2">
                  <div className="flex h-full items-start">
                    {stat.icon && (
                      <div className="me-4 flex-shrink-0">
                        <span className={`avatar bg-${stat.color} !text-white`}>
                          <i className={stat.icon + ' text-[1.125rem]'}></i>
                        </span>
                      </div>
                    )}
                    <div className="flex-grow overflow-hidden">
                      <span className="mb-1 block truncate !p-0 font-semibold !text-white dark:text-white/50">
                        {stat.title}
                      </span>
                      {<h5 className="mb-1 text-center text-[1.25rem] font-semibold">{String(stat.value)}</h5>}
                      {stat.subtitle && (
                        <p className="!m-0 mb-0 truncate !p-0">
                          <span className={`badge bg-${stat.color}/10 text-${stat.color} !p-0 !pr-1`}>
                            {stat.subtitle}
                          </span>
                          {stat.subValue && (
                            <span className={`font-badge bg-${stat.color}/10 text-${stat.color} !p-0 !pr-1`}>
                              {stat.subValue}
                            </span>
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default PositionDetailStats;
